import { useEffect, useState } from "react";
import { LabsService } from "../../../../Services/Labs.service";
import { Table, Dropdown, DropdownButton, Pagination } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import navdots from "../../../../Assets/images/navdots.svg";
import Toaster from "../../../../Components/Toaster";
import { Link } from "react-router-dom";
import SearchInput from "../../../../Components/AdministrativeSettings/SearchInput";
import TablePagination from "../../../../Components/AdministrativeSettings/TablePagination";
import LabHolidayTableRow from "../../../../Components/AdministrativeSettings/LabManagement/LabHolidayTableRow";
import Loader from "../../../../Components/Loader";
import { AdminService } from "../../../../Services/Admin.service";
import { useMediaQuery } from "react-responsive";
import LoadingComponent from "../../../../Components/LoadingComponent";
import NoListDataAvailable from "../../../../Components/NoListDataAvailable";

function LabHolidayList(props) {
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [totalHoliday, setHolidayTotal] = useState(0);
    const [holidaylist, setHolidayList] = useState([]);    

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });

    const [searchName, setSearchName] = useState("");
    const [isSearchInputVisible, setSearchInputVisible] = useState(false);
    const [statuses, setStatuses] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [loading, setLoading] = useState(false);

    const { isClearFilter } = props;
    const { onFilterCountChange } = props;

    useEffect(() => {
        if (isClearFilter) {
            setSelectedStatuses([]);
            setSearchName("");
            setSearchInputVisible(false);
            onFilterCountChange(0);
        }
    }, [isClearFilter]);

    useEffect(() => {
        const count = [
            selectedStatuses.length > 0 ? 1 : 0,
            searchName ? 1 : 0,
        ].reduce((sum, val) => sum + val, 0);

        onFilterCountChange(count);
    }, [selectedStatuses, searchName]);

    useEffect(() => {
        fetchStatuses();
    }, []);

    useEffect(() => {
        fetchHolidayList();
    }, [pagination, selectedStatuses, searchName]);

    function fetchHolidayList() {
        const filters = {
            name: searchName,
            status: selectedStatuses,
        };

        const params = {
            limit: pagination.limit,
            offset: pagination.offset,
            filters: [filters],
        };

        setLoading(true);
        LabsService.getHolidayList(params)
        .then((response) => {              
            setHolidayList(response.data.list);
            setHolidayTotal(response.data.total);
            setLoading(false);
        })
        .catch((error) => {
            setToastMessage(error.message || 'Something went wrong.');
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        });
    }

    function fetchStatuses() {
        AdminService.getAdminListStatusTypes()
          .then((statusTypes) => {
            setStatuses(statusTypes);
    
          })
          .catch((error) => {
            console.error("Failed to fetch status types", error);
          });
    }

    const handleStatusChange = (status) => {
        if (selectedStatuses.includes(status)) {
          setSelectedStatuses(selectedStatuses.filter((s) => s !== status));
        } else {
          setSelectedStatuses([...selectedStatuses, status]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {
        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(totalHoliday);
            setPagination({ limit: totalHoliday, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = holidaylist.length;  //ex 10 
    const totalPages = Math.ceil(totalHoliday / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };

    const handleDeleteUser = async (holidayId) => {
        try {
          
          setLoading(true);
          const response = await LabsService.deleteLabHoliday(holidayId);
    
          if (response.status == true) {
            setToastMessage(response.message);
            setToastVariant('success');
            fetchHolidayList();
          }
          else {
            setToastMessage(response.message);
            setToastVariant('error');
          }
        } catch (error) {
            setToastMessage(error.message || 'Something went wrong.');
            setToastVariant('error');
        } finally {
            setLoading(false);
            setShowToast(true);
        }
    };
    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <>
        <Loader loading={loading} />
        <div>
        {isMobile ? (
           <div className="admin-card-list mt-3">
            {holidaylist.length > 0 ? (
              <div  className="row"> 
              {
                holidaylist.map((holiday, index) => (
              <div className="col-sm-12 col-md-6 mb-3" key={index}>
               <LabHolidayTableRow
                    key={index}
                    holiday={holiday}
                    handleDeleteUser={handleDeleteUser} 
                />
              </div>
            ))}</div>) : (<NoListDataAvailable type="lab-holidays" />)}
{/* 
                    {holidaylist.map((holiday, index) => (
                        <LabHolidayTableRow
                            key={index}
                            holiday={holiday}
                            handleDeleteUser={handleDeleteUser} 
                        />
                    ))} */}

         </div>
         ):(<>
         

            <div className={`${totalHoliday>3 ? 'morethan-3' : 'lessthan-3'} el-table-container el-board-table`}>
                <Table hover >
                    <thead>
                        <tr>
                            <th>
                                <div className="el-table-input">
                                    <SearchInput
                                        label="Lab"
                                        value={searchName}
                                        setValue={setSearchName}
                                        isVisible={isSearchInputVisible}
                                        setVisible={setSearchInputVisible}
                                    />
                                </div>
                            </th>
                            <th>
                                <div className="el-table-input">
                                    <label>Date</label>
                                </div>
                            </th>
                            <th>
                                <div className="el-table-input">
                                    <label>Reason</label>
                                </div>
                            </th>                            
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {Array.isArray(holidaylist) && holidaylist.length > 0 ? (
                        holidaylist.map((holiday, index) => (
                            <LabHolidayTableRow
                                key={index}
                                holiday={holiday}
                                handleDeleteUser={handleDeleteUser} 
                            />
                        ))
                    ) : ( <NoListDataAvailable type="holidays" /> )}
                    </tbody>
                </Table>
            </div>


            </>
         )}
            <TablePagination
                rowsPerPage={rowsPerPage}
                handleRowsPerPageChange={handleRowsPerPageChange}
                pagination={pagination}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
            />
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </div>
        </>
    );

}

export default LabHolidayList;